<script setup>
const props = defineProps(["informations", "progress"]);

const scrollToAnchor = (event) => {
  const targetId = event.target.hash.substring(1);
  const targetElement = document.getElementById(targetId);
  if (targetElement) {
    setTimeout(() => {
      window.scrollTo({
        top: targetElement.offsetTop - targetElement.offsetHeight,
        left: 0,
        behavior: "smooth",
      });
    }, 500);
  }
};
</script>

<template>
  <div class="position-sticky top-0 pt-2">
    <span class="h6">INFORMAZIONI RICHIESTE</span>
    <div class="progress mb-2">
      <div
        class="progress-bar"
        role="progressbar"
        :style="`width: ${progress}%`"
        :aria-valuenow="progress"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-label="Progresso nel completamento del flusso della prenotazione"
      ></div>
    </div>
    <div class="d-flex flex-column text-primary">
      <div
        class="p-2 bd-highlight"
        v-for="information in props.informations || []"
        :key="information"
      >
        <a
          :href="`#${encodeURIComponent(information)}`"
          class="text-decoration-none"
          @click.prevent="scrollToAnchor"
        >
          {{ information }}
        </a>
      </div>
    </div>
  </div>
</template>
